import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
import { compare } from '../../../ui/dashboard-tarjeta/_helpers/compare';

class ButtomColumn {
  column!: string;
  matIcon!: string;
  text?: boolean;
  optionalContent?: boolean;
}

class EventColumn {
  column!: string;
  data: any;
}

export function getDutchPaginatorIntl() {
  const paginatorIntl = new MatPaginatorIntl();

  paginatorIntl.itemsPerPageLabel = 'Elementos por página';
  paginatorIntl.nextPageLabel = 'Siguiente';
  paginatorIntl.previousPageLabel = 'Anterior';
  paginatorIntl.lastPageLabel = 'Ultima página';

  return paginatorIntl;
}

@Component({
  selector: 'app-simple-table',
  templateUrl: './simple-table.component.html',
  styleUrls: ['./simple-table.component.scss'],
})
export class SimpleTableComponent implements AfterViewInit, OnChanges {
  @ViewChild(MatPaginator, { static: false }) readonly paginator!: MatPaginator;
  @Input() data: any[];
  @Input() tableColumns: string[];
  @Input() tableTitles: string[];
  @Input() multimediaColumn: any[];
  @Input() urlColumn: any[];
  @Input() stateColumn: any[];
  @Input() iconColumn: any[];
  @Input() columnHidden: string[];
  @Input() noSortColumn: string[];
  @Input() buttomcolumn: ButtomColumn[];
  @Input() dateColumn: string[];
  @Input() classTable: string;
  @Input() styleTable: string;
  @Input() tableCenter: boolean;
  @Input() textSearch!: string;
  @Input() path: string;
  @Input() isSelectable: boolean;
  @Input() minWidthColumn: string;
  @Output() valueEvent: EventEmitter<EventColumn>;

  urlServer: string;
  selection: SelectionModel<any>;
  dataSource: MatTableDataSource<any>;

  constructor(private datePipe: DatePipe) {
    this.data = [];
    this.isSelectable = false;
    this.dataSource = new MatTableDataSource<any>([]);
    this.tableColumns = [];
    this.path = '';
    this.tableTitles = [];
    this.columnHidden = [];
    this.multimediaColumn = [];
    this.iconColumn = [];
    this.urlColumn = [];
    this.stateColumn = [];
    this.buttomcolumn = [];
    this.valueEvent = new EventEmitter<EventColumn>();
    this.classTable = '';
    this.styleTable = '';
    this.noSortColumn = [];
    this.selection = new SelectionModel<any>(true, []);
    this.dateColumn = [];
    this.tableCenter = false;
    this.minWidthColumn = 'none';
    this.urlServer = environment.dashboard;
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('textSearch' in changes) {
      this.search(this.textSearch);
    }
    if ('isSelectable' in changes && this.isSelectable) {
      if (!this.tableColumns.includes('customSelectSimpleTable')) {
        this.tableColumns.unshift('customSelectSimpleTable');
        this.tableTitles.unshift('customSelectSimpleTable');
      }
    }
    if ('data' in changes) {
      this.dataSource.data = this.data;

      this.dataSource.data.forEach((data) => {
        this.dateColumn.forEach((dateColumn) => {
          data[dateColumn + 'DateCustom'] = this.datePipe.transform(
            data[dateColumn],
            'dd/MM/yyyy'
          );
        });
      });
    }
  }

  sortData(sort: Sort): void {
    this.dataSource.data = this.dataSource.data.sort((a, b) => {
      const isAsc: boolean = sort.direction === 'asc';
      if (!this.noSortColumn.includes(sort.active)) {
        return compare(a[sort.active], b[sort.active], isAsc);
      }

      return 0;
    });
  }

  notShowColumn(column: string): boolean {
    return this.columnHidden.some((item) => item === column) ? true : false;
  }

  isButtomColumn(column: string): boolean {
    return this.buttomcolumn.some((item) => item.column === column)
      ? true
      : false;
  }

  getIconColumn(column: string): string {
    return this.buttomcolumn.find((item) => item.column === column)!.matIcon;
  }

  optionalContent(column: string, data: any): boolean {
    const aux = this.buttomcolumn.find(
      (item) => item.column === column
    )!.optionalContent;
    if (!data && aux) {
      return false;
    }
    return true;
  }

  getimageColumn(value: string) {
    // const image = this.imageColumn.find((item) => item.column === column);

    // const path = `http://localhost:3000/api/v1/files/${image.path}/${value}`;
    return '';
  }

  getExtension(value: string): string | undefined {
    if (typeof value === 'object' && value !== null) return;
    return value.split('.').pop();
  }

  isUrlColumn(column: string): boolean {
    return this.urlColumn.some((item) => item === column) ? true : false;
  }

  isImageColumn(column: string): boolean {
    return this.multimediaColumn.some((item) => item === column) ? true : false;
  }

  isStateColumn(column: string): boolean {
    return this.stateColumn.some((item) => item === column) ? true : false;
  }

  isIconColumn(column: string): boolean {
    return this.iconColumn.some((item) => item === column) ? true : false;
  }

  getButtomTextColumn(column: string): boolean | undefined {
    return this.buttomcolumn.find((item) => item.column === column)!.text;
  }

  setEvent(column: string, data: any): void {
    this.valueEvent.emit({
      column: column,
      data: data,
    });
  }

  search(search: string): void {
    this.dataSource.filter = search;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource.data);
  }

  isDate(column: string): boolean {
    return this.dateColumn.some((item) => item === column) ? true : false;
  }
}
